import React from 'react';

import styles from "./ranking-badge.module.scss";
import classNames from "classnames";

export const RankingBadge = (props) => {
  const linkProps = {
    className: classNames(props.className, {[styles.small_view]: props.isSmallView}, styles[props.badgeClassName]),
    onClick: () => props.onClick && props.onClick()
  }

  return (
    <div {...linkProps}>
      <div className={classNames(styles.text_container, props.textClassName)}>{props.text}</div>
    </div>

  )
}
